export default __webpack_public_path__ + "static/media/9564.1617619490.dae293b2-ddc3-4445-89b7-476753e5f389.027b2c9e.webp";